import * as Schema from "effect/Schema";
import { PositiveInt, ProjectId, TrimmedNonEmptyString } from "./baseSchemas.js";
const PROJECT_SEARCH_ENTRIES_MAX_LIMIT = 200;
const PROJECT_RELATIVE_PATH_MAX_LENGTH = 512;
export const ProjectSearchEntriesInput = Schema.Struct({
    projectId: ProjectId,
    query: TrimmedNonEmptyString.check(Schema.isMaxLength(256)),
    limit: PositiveInt.check(Schema.isLessThanOrEqualTo(PROJECT_SEARCH_ENTRIES_MAX_LIMIT)),
});
const ProjectEntryKind = Schema.Literals(["file", "directory"]);
export const ProjectEntry = Schema.Struct({
    path: TrimmedNonEmptyString,
    kind: ProjectEntryKind,
    parentPath: Schema.optional(TrimmedNonEmptyString),
});
export const ProjectSearchEntriesResult = Schema.Struct({
    entries: Schema.Array(ProjectEntry),
    truncated: Schema.Boolean,
});
export class ProjectSearchEntriesError extends Schema.TaggedError()("ProjectSearchEntriesError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
export const ProjectDocumentsStatusInput = Schema.Struct({
    projectId: ProjectId,
});
export const ProjectDocumentState = Schema.Literals([
    "ok",
    "unparsed",
    "stale",
    "failed",
    "orphaned",
    "unsupported",
]);
export const ProjectDocumentFile = Schema.Struct({
    path: TrimmedNonEmptyString,
    state: ProjectDocumentState,
    restorable: Schema.Boolean,
    sha256: Schema.NullOr(Schema.String),
    size: Schema.NullOr(Schema.Number),
    mtimeMs: Schema.NullOr(Schema.Number),
    parsedAt: Schema.NullOr(Schema.String),
    pageCount: Schema.NullOr(Schema.Number),
    resultPath: Schema.NullOr(Schema.String),
    error: Schema.NullOr(Schema.String),
});
export const ProjectDocumentsCounts = Schema.Struct({
    ok: Schema.Number,
    unparsed: Schema.Number,
    stale: Schema.Number,
    failed: Schema.Number,
    orphaned: Schema.Number,
    unsupported: Schema.Number,
});
export const ProjectDocumentsStatusResult = Schema.Struct({
    root: TrimmedNonEmptyString,
    counts: ProjectDocumentsCounts,
    files: Schema.Array(ProjectDocumentFile),
});
export class ProjectDocumentsStatusError extends Schema.TaggedError()("ProjectDocumentsStatusError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
export const ProjectDeleteDocumentInput = Schema.Struct({
    projectId: ProjectId,
    relativePath: TrimmedNonEmptyString.check(Schema.isMaxLength(PROJECT_RELATIVE_PATH_MAX_LENGTH)),
    reconcile: Schema.optional(Schema.Boolean),
});
export const ProjectDeleteDocumentResult = Schema.Struct({
    relativePath: TrimmedNonEmptyString,
});
export class ProjectDeleteDocumentError extends Schema.TaggedError()("ProjectDeleteDocumentError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
export const ProjectOutputStatusInput = Schema.Struct({
    projectId: ProjectId,
});
export const ProjectOutputFile = Schema.Struct({
    path: TrimmedNonEmptyString,
    size: Schema.Number,
    mtimeMs: Schema.NullOr(Schema.Number),
});
export const ProjectOutputStatusResult = Schema.Struct({
    root: TrimmedNonEmptyString,
    /**
     * The output tree's path relative to the workspace root, so the client can
     * build hosted `/artifacts/` routes without knowing the workspace layout.
     */
    artifactsPrefix: TrimmedNonEmptyString,
    files: Schema.Array(ProjectOutputFile),
});
export class ProjectOutputStatusError extends Schema.TaggedError()("ProjectOutputStatusError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
export const ProjectCopyOutputToMaterialsInput = Schema.Struct({
    projectId: ProjectId,
    relativePath: TrimmedNonEmptyString.check(Schema.isMaxLength(PROJECT_RELATIVE_PATH_MAX_LENGTH)),
    reconcile: Schema.optional(Schema.Boolean),
});
export const ProjectCopyOutputToMaterialsResult = Schema.Struct({
    relativePath: TrimmedNonEmptyString,
});
export class ProjectCopyOutputError extends Schema.TaggedError()("ProjectCopyOutputError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
export const ProjectDeleteOutputFileInput = Schema.Struct({
    projectId: ProjectId,
    relativePath: TrimmedNonEmptyString.check(Schema.isMaxLength(PROJECT_RELATIVE_PATH_MAX_LENGTH)),
});
export const ProjectDeleteOutputFileResult = Schema.Struct({
    relativePath: TrimmedNonEmptyString,
});
export class ProjectDeleteOutputError extends Schema.TaggedError()("ProjectDeleteOutputError", {
    message: TrimmedNonEmptyString,
    cause: Schema.optional(Schema.Defect()),
}) {
}
